// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"241":"31fecd48","549":"5bbe0c97","850":"c23edd48"}[chunkId] + ".chunk.js";
};